// extracted by mini-css-extract-plugin
export var boxItems = "_1f-1";
export var button = "_1f-5";
export var filterGroupBox = "_1f-0";
export var icon = "_1f-2";
export var iconSecondary = "_1f-4";
export var iconWrapper = "_1f-3";